<template>
  <button type="button" class="next" :class="{ show: show }">
    <div class="icon-wrapper">
      <icon
        class="icon"
        size="4rem"
        name="fluent-emoji:backhand-index-pointing-left"
      />
    </div>
  </button>
</template>
<script lang="ts" setup>
interface Props {
  delay?: number;
  tag?: string;
}
const props = defineProps({
  delay: { default: 1000 },
  tag: { default: 'p' }
});
const show = ref(false);
let timeout;
onMounted(() => {
  timeout = setTimeout(() => {
    show.value = true;
  }, props.delay);
});
onUnmounted(() => {
  clearTimeout(timeout);
});
</script>
<style lang="scss" scoped>
.next .icon {
  transform: scaleX(-1);
}
.icon-wrapper {
  position: relative;
}
.next {
  position: relative;
  padding-left: 3rem;
  transform: translateX(-20px);
  transition: opacity 200ms $ease-in-quad, transform 200ms $ease-out-quad;
  opacity: 0;
  &.show {
    transform: translateX(0);
    opacity: 1;
  }
  &:hover,
  &:focus {
    .icon-wrapper {
      animation: bound-anim 800ms;
    }
  }
}

@keyframes bound-anim {
  0%,
  100% {
    left: 0;
    transform: scale(1);
  }
  30% {
    left: -25%;
  }
  50% {
    transform: scale(1);
  }
  80% {
    left: 0;
    transform: scale(0.9, 1.1);
  }
}
</style>
